import moment from 'moment';

// todo: add setster to constants
import { LESSON_API_ROOT } from "./constants";
import { getSetsterLocationID } from '../utils/booking-config';

const SETSTER_TOKEN_URL = LESSON_API_ROOT + '/token';
const SETSTER_SERVICES_URL = LESSON_API_ROOT + '/services';
const SETSTER_MONTH_AVAILABILITY_URL = LESSON_API_ROOT + '/availability/lesson/month';
const SETSTER_DATE_AVAILABILITY_URL = LESSON_API_ROOT + '/availability/lesson/date';

export class BookingService {

  apiToken;
  tempCache = {};

  /*
    Initialize API requests by getting the access token
   */
  getAPIToken() {
    return new Promise((resolve) => {
      if (this.apiToken) {
        resolve(this.apiToken);
      } else {
        const request = new Request(SETSTER_TOKEN_URL, {});
        fetch(request)
          .then((response) => response.json())
          .then(json => {
            this.apiToken =  json.session_token;
            resolve(this.apiToken);
        });
      }
    });
  }

  _formServicesObjectFromAPIJson(apiResponse) {
    let services = {};
    if (!apiResponse || !apiResponse.data) {
      return services;
    } else {
      apiResponse.data.forEach(service => {
        services[service.id] = this.formatServiceData(service);
      });

      return services;
    }
  }

  getServices(serviceIds /*Array of IDs*/) {
    return new Promise((resolve) => {
      const REQUEST_URL = `${SETSTER_SERVICES_URL}?services=${serviceIds.join(',')}`;
      const request = new Request(REQUEST_URL);
      const cached = this.getCacheFor(REQUEST_URL);
      if (cached) {
        resolve(cached);
      } else {
        fetch(request)
          .then((response) => response.json())
          .then(json => {
            let services = this._formServicesObjectFromAPIJson(json);
            this.setCacheFor(REQUEST_URL, services);
            resolve(services);
          });
      }
    });
  }

  parseServiceIdsFromProData(proData) {
    const services = proData.services;

    let ids = {};
    services.forEach(service => {
      service.service_types.forEach(type => {
        ids[type.service_id] = type.service_id;
      })
    });

    return Object.keys(ids);
  }

  getAvailabilitiesForMonth(serviceId, month, location_id, calendar_uid) {
    
    const location = location_id || getSetsterLocationID();

    return new Promise((resolve) => {
        const REQUEST_URL = `${ SETSTER_MONTH_AVAILABILITY_URL }?service=${ serviceId }&date=${ month.format('YYYY-MM-DD') }&location_id=${location}&provider=${calendar_uid}`;

        const cached = this.getCacheFor(REQUEST_URL);

        if (cached) {
          resolve(cached);
        } else {
          const request = new Request(REQUEST_URL);
          fetch(request)
            .then(response => {
              response.json().then(json => {
                const {
                  blockedDates,
                  rest
                } = this.parseBlockedDatesForMonth(json.data, month);

                const result = { blockedDates, rest };

                this.setCacheFor(REQUEST_URL, result);

                resolve(result);
              });
            });
        }
    })
  }

  getAvailabilityForDate(serviceId, date, service, location_id, calendar_uid) {
    const location = location_id || getSetsterLocationID();

    return new Promise((resolve) => {
      const REQUEST_URL = `${ SETSTER_DATE_AVAILABILITY_URL }?service=${ serviceId }&date=${ date.format('YYYY-MM-DD') }&location_id=${location}&provider=${calendar_uid}`;
      const cached = this.getCacheFor(REQUEST_URL);

        if (cached) {
          resolve(cached);
        } else {
          const request = new Request(REQUEST_URL);

          fetch(request)
            .then(response => {
              response.json().then(json => {

                let availabilities = [];
                const {
                  data: {
                    times
                  } = {}
                } = json

                if (times && times[date.format('YYYY-MM-DD')]) {
                  const hourArray = times[date.format('YYYY-MM-DD')];
                  if (hourArray) {
                    const dateStr = date.format('YYYY-MM-DD');
                    let id = 0;
                    hourArray.forEach(hour => {
                      availabilities.push({
                        id: id++,
                        time: moment(`${dateStr} ${hour}`),
                        price: service.price,
                        serviceId: serviceId
                      });
                    });
                  }
                }

                const result = {
                  noTeachingForDate: availabilities.length === 0,
                  times: availabilities,
                };

                this.setCacheFor(REQUEST_URL, result);

                resolve(result);
              });
            });
        }
    });
  }

  parseBlockedDatesForMonth(monthData, month) {
    const strStartDate = month.format('YYYY-MM-01');
    const startDate = moment(strStartDate);
    const endOfMonth = moment(strStartDate).endOf('month');

    const _monthData = monthData.map(month => {
      month.date = moment(month.date);
      return month;
    });

    const blockedDates = [];
    const rest = [];

    while (startDate.isBetween(strStartDate, endOfMonth, 'day', '[]')) {

      const foundDate = _monthData.find((month) => { return month.date.isSame(startDate, 'day') })

      if (foundDate) {
        if (foundDate.times.length === 0) {
          blockedDates.push(foundDate);
        } else {
          rest.push(foundDate);
        }
      } else {
        blockedDates.push(startDate.clone());
      }

      startDate.add(1, 'days');
    }

    return { blockedDates, rest };
  }

  formatServiceData(service) {

    const _service = {
      id: parseInt(service.id, 10),
      name: service.name,
      description: service.description,
      resource_id: service.custom_resource_id,
      photo: service.photo,
      price: {
        price_value: parseInt(service.price, 10)
      },
      subServices: service.subservices,
      duration: parseInt(service.duration, 10),
      schedule: {
        activeFrom: service.active_from,
        activeUntil: service.active_until,
        times: service.schedule
      }
    };

    return _service;
  }

  getCacheFor(key) {
    return this.tempCache[key];
  }

  setCacheFor(key, val) {
    this.tempCache[key] = val;
  }
}



// WEBPACK FOOTER //
// ./src/api/booking-service.js